module.exports = __webpack_public_path__ + "static/media/formations.eaf89019.png";